/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CompanyIndustryRequest = {
    AviationAerospace: 'AVIATION_AEROSPACE',
    It: 'IT',
    Food: 'FOOD',
    Architecture: 'ARCHITECTURE',
    Crafts: 'CRAFTS',
    CivicSocial: 'CIVIC_SOCIAL',
    Automobile: 'AUTOMOBILE',
    BankingInsurance: 'BANKING_INSURANCE',
    Biotech: 'BIOTECH',
    CivilEngineering: 'CIVIL_ENGINEERING',
    Research: 'RESEARCH',
    Chemical: 'CHEMICAL',
    Film: 'FILM',
    SmallRetail: 'SMALL_RETAIL',
    Consulting: 'CONSULTING',
    Culture: 'CULTURE',
    Military: 'MILITARY',
    Leisure: 'LEISURE',
    ECommerce: 'E_COMMERCE',
    Publishing: 'PUBLISHING',
    Education: 'EDUCATION',
    Software: 'SOFTWARE',
    Energy: 'ENERGY',
    Environment: 'ENVIRONMENT',
    Retail: 'RETAIL',
    HighTech: 'HIGH_TECH',
    Hospitality: 'HOSPITALITY',
    RealEstate: 'REAL_ESTATE',
    ImportExport: 'IMPORT_EXPORT',
    Mechanical: 'MECHANICAL',
    Primary: 'PRIMARY',
    Pharma: 'PHARMA',
    Games: 'GAMES',
    Luxury: 'LUXURY',
    Cosmetics: 'COSMETICS',
    Nanotech: 'NANOTECH',
    Iot: 'IOT',
    Press: 'PRESS',
    Social: 'SOCIAL',
    Hr: 'HR',
    Restaurants: 'RESTAURANTS',
    Health: 'HEALTH',
    Medical: 'MEDICAL',
    Public: 'PUBLIC',
    Safety: 'SAFETY',
    Sports: 'SPORTS',
    Telecom: 'TELECOM',
    Transport: 'TRANSPORT',
    Logistic: 'LOGISTIC',
    Travel: 'TRAVEL',
    Wine: 'WINE',
    Legal: 'LEGAL',
    PrivateEquity: 'PRIVATE_EQUITY'
} as const;
export type CompanyIndustryRequest = typeof CompanyIndustryRequest[keyof typeof CompanyIndustryRequest];


export function instanceOfCompanyIndustryRequest(value: any): boolean {
    for (const key in CompanyIndustryRequest) {
        if (Object.prototype.hasOwnProperty.call(CompanyIndustryRequest, key)) {
            // @ts-ignore
            if (CompanyIndustryRequest[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CompanyIndustryRequestFromJSON(json: any): CompanyIndustryRequest {
    return CompanyIndustryRequestFromJSONTyped(json, false);
}

export function CompanyIndustryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyIndustryRequest {
    return json as CompanyIndustryRequest;
}

export function CompanyIndustryRequestToJSON(value?: CompanyIndustryRequest | null): any {
    return value as any;
}

